module.exports = __webpack_public_path__ + "static/media/blood-clot.f963efed.svg";